<template>
  <div>
    <v-dialog persistent v-model="show" max-width="760">
      <v-card>
        <v-card-title class="headline">Cuenta</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :error-messages="cuentaErrors"
                  @input="$v.objetoCuenta.Cuenta.$touch()"
                  @blur="$v.objetoCuenta.Cuenta.$touch()"
                  v-model="objetoCuenta.Cuenta"
                  autofocus
                  dense
                  label="Cuenta"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :error-messages="descripcionErrors"
                  @input="$v.objetoCuenta.Descripcion.$touch()"
                  @blur="$v.objetoCuenta.Descripcion.$touch()"
                  v-model="objetoCuenta.Descripcion"
                  dense
                  label="Descripción"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="$emit('cerrar-modal-descuento')" text
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" @click="insertarCuenta()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loaderCuentas">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

const cuentaRegex = /^([0-9]{1,15})$/;
const descripcionRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 !@#$%^&*/|().,´"'_+]||[\n]){1,60})$/;

export default {
  validations: {
    objetoCuenta: {
      Cuenta: {
        required,
        cuentaValida(Cuenta) {
          return cuentaRegex.test(Cuenta);
        }
      },
      Descripcion: {
        required,
        descripcionValida(Descripcion) {
          return descripcionRegex.test(Descripcion);
        }
      }
    }
  },
  data: () => ({
    loaderCuentas: false,
    voyAInsertar: true,
    objetoCuenta: {
      Cuenta: "",
      Descripcion: ""
    }
  }),
  props: {
    cuentaPasada: Object,
    show: Boolean
  },
  computed: {
    ...mapState("cuentas", {
      cuentaList: state => state.cuentas
    }),
    descripcionErrors() {
      const errors = [];
      if (!this.$v.objetoCuenta.Descripcion.$dirty) return errors;
      !this.$v.objetoCuenta.Descripcion.required &&
        errors.push("El campo descripción es requerido.");
      !this.$v.objetoCuenta.Descripcion.descripcionValida &&
        errors.push("El campo descripción no tiene el formato correcto.");
      return errors;
    },
    cuentaErrors() {
      const errors = [];
      if (!this.$v.objetoCuenta.Cuenta.$dirty) return errors;
      !this.$v.objetoCuenta.Cuenta.required && errors.push("El campo cuenta es requerido.");
      !this.$v.objetoCuenta.Cuenta.cuentaValida &&
        errors.push("El campo cuenta no tiene el formato correcto.");
      return errors;
    }
  },
  mounted() {
    if (this.cuentaPasada.ID) {
      this.voyAInsertar = false;
      this.objetoCuenta.Cuenta = this.cuentaPasada.CUENTA;
      this.objetoCuenta.Descripcion = this.cuentaPasada.DESCRIPCION;
      this.objetoCuenta.Id = this.cuentaPasada.ID;
    } else {
      this.voyAInsertar = true;
    }
  },
  methods: {
    ...mapActions("cuentas", ["insertCuentas", "editCuentas"]),
    async insertarCuenta() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else if (this.voyAInsertar) {
        this.loaderCuentas=true;
        const res = await this.insertCuentas(this.objetoCuenta);
        if (res[0]) {
          this.$emit("muestraDialogExito", "Descuento insertado con éxito");
          this.loaderCuentas=false;
        } else {
          this.$emit("muestraModalErrorEnAccion", res[1]);
          this.loaderCuentas=false;
        }
      } else {
        this.loaderCuentas=true;
        const res = await this.editCuentas(this.objetoCuenta);
        if (res[0]) {
          this.$emit("muestraDialogExito", "Descuento editado con éxito");
          this.loaderCuentas=false;
        } else {
          alert("error");
          //TODO revisar porque tienes este alert aqui
          this.loaderCuentas=false;
        }
      }
    }
  }
};
</script>

<style lang="css"></style>
